import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { api, apiPublic } from '@/plugins/axios.js'
import { vue } from '@/main.js'

// Retorna os dados
/**
 * @param {int} cod_ibge - IBGE do município
 */
export async function getDados(cod_ibge) {
  try {
    const { data } = await api.get('/app/pessoas-por-idade/' + cod_ibge)
    return data
  } catch (err) {
    console.log(err)
  }
}

export function generatePdf(cadastros) {
  const titlePdf = 'Calculadora de pessoas'
  const titlePdfSave = utils.methods.titlePdf(titlePdf)
  const descriptionPdf = 'Quantidade de pessoas por idade e equipes de saúde'
  const headersPdf = ['ESTABELECIMENTO', 'EQUIPE', 'INE', 'IDADE', 'PESSOAS']

  const dataPdf = cadastros.map((item) => {
    let dados = JSON.parse(item.dados)
    let estabelecimento = dados.no_unidade_saude ?? ''
    let no_equipe = dados.no_equipe ?? ''

    return {
      estabelecimento: estabelecimento,
      no_equipe: no_equipe,
      ine: item.ine,
      idade: item.idade,
      pessoas_idade: item.pessoas_idade,
    }
  })

  const table = dataPdf.map((row) => Object.values(row))
  const doc = new jsPDF(utils.methods.encryptionPdf())

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64Brasao) => {
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64Brasao,
        titlePdf,
        descriptionPdf
      )

      const totalPessoas = cadastros.reduce(
        (sum, item) => sum + parseInt(item.pessoas_idade, 10),
        0
      )
      doc.setFontSize(12)
      doc.text(
        `Total de pessoas: ${totalPessoas}`,
        15,
        verticalPosition,
        null,
        null,
        'left'
      )

      verticalPosition += 6
      const dataAtual = new Date().toLocaleDateString('pt-BR')
      doc.text(`Data: ${dataAtual}`, 15, verticalPosition)

      verticalPosition += 6

      doc.autoTable({
        head: [headersPdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: ({ row, section }) => {
          if (section === 'head') doc.setTextColor(0, 0, 0)
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)
      doc.save(`${titlePdfSave}.pdf`)

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}
